export default {
  log_activity: 'Log this activity:',
  learn_more: 'Learn more about this activity:',
};
